<template>
  <div class="c-box">
    <div>
      <div class="flex align-items-center">
        <img class="img-box" src="../../assets/images/img44.png" alt="" />
        <!-- <span class="text1">评审时间设置</span> -->
        <span class="text1">评审时间设置</span>
      </div>
      <div class="flex">
        <div class="time-compontent">
          <div>
            <!-- <span>评审时间设置：</span> -->
            <a-range-picker
              :show-time="{ format: 'HH:mm' }"
              format="YYYY-MM-DD HH:mm"
              @change="onChange"
              @ok="onOk"
              :disabled="isRanagePickerDisabled"
              v-model="currentTime"
              :locale="locale"
            />
          </div>
        </div>
        <div class="flex flex-center">
          <div class="btn-box flex flex-between">
            <div v-if="isDisabled" class="btn border-btn" @click="editTime">
              编辑
            </div>
            <div v-else class="btn bg-btn" @click="selectTimeOk">完成</div>
          </div>
        </div>
      </div>
      <div class="flex align-items-center" style="margin-top:10px;">
        <img class="img-box" src="../../assets/images/img44.png" alt="" />
        <!-- <span class="text1">评审时间设置</span> -->
        <span class="text1">评审设置</span>
      </div>
      <div class="flex" style="margin-bottom:10px;">
        <div class="time-compontent" style="margin-right:30px;">
          <div>
            <span>是否评审：</span>
            <a-switch checked-children="是" @change="qhReview"  v-model="izReview"   un-checked-children="否"  />
          </div>
        </div>
        <div class="time-compontent">
          <div>
            <span>是否打分：</span>
            <a-switch checked-children="是" @change="qhScore" v-model="izScoring"  un-checked-children="否"  />
          </div>
        </div>
      </div>
    </div>
    <!--<div class="">
      <div class="text-box">
        <div class="flex align-items-center">
          <img class="img-box" src="../../assets/images/img45.png" alt="" />
          <span class="text1">评审范围</span>
        </div>
      </div>
    </div>
    <div class="line-style"></div>-->
    <a-tabs default-active-key="1" @change="callback">
    	 <a-tab-pane key="1" tab="评审范围" force-render>
    	 	     <div class="flex">
						      <div v-for="(item, index) in list" :key="index">
						        <div
						          class="review-menu"
						          :class="item.isShow ? 'bg-btn' : ''"
						          @click="openTree(item, index)"
						        >
						          {{ item.text }}
						          <div class="arrow_down" v-if="item.isShow"></div>
						        </div>
						      </div>
						    </div>
						    <div v-for="(item, index) in list" :key="index">
						      <div v-if="item.isShow">
						        <div class="review-menu-content">
						          <div class="tree-box">
						            <a-tree
						              :treeData="item.school"
						              checkable
						              :replaceFields="{
						                children: 'applyVoList',
						                title: 'realname',
						                key: 'id',
						              }"
						              @check="onCheckTree"
						            >
						              <template slot="school" slot-scope="item1">
						                <div class="flex">
						                  <div
						                    :title="item1.realname"
						                    class="nowrap"
						                    style="max-width: 300px"
						                  >
						                    {{ item1.realname }}
						                  </div>
						                  <span style="color: #000" v-if="item1.applyVoList.length > 0"
						                    >(共
						                    <span style="color: #9A0B00"
						                      >{{ item1.applyVoList.length }} </span
						                    >个作品 ,
						                    <span style="color: #9A0B00">{{
						                      getApplyVoNum(item1.applyVoList)
						                    }}</span
						                    >个作品未设置)</span
						                  >
						                </div>
						              </template>
						              <template slot="expert" slot-scope="item">
						                <div class="flex flex-between">
						                  <div :title="item.zpname" class="flex-1 nowrap" style="max-width:700px;">
						                    {{item.zpname}}
						                  </div>
						                  <div
						                    style="width: 300px; margin-left: 20px; text-align: right"
						                    class="nowrap"
						                    :title="item.expertList"
						                  >
						                    <span v-for="(val, index) in item.expertList" :key="index">
						                      <span>
						                        {{
						                          index === item.expertList.length - 1
						                            ? `  ${val}`
						                            : `${val}  , `
						                        }}
						                      </span>
						                    </span>
						                  </div>
						                </div>
						              </template>
						            </a-tree>
						          </div>
						        </div>
						        <div class="flex flex-center">
						          <div
						            class="add-btn"
						            :class="onCheckIdList && onCheckIdList.length > 0 ? '' : 'opacity6'"
						            @click="showBindExpertPop"
						          >
						            添加专家
						          </div>
						        </div>
						      </div>
						    </div>
    	 	</a-tab-pane>
    	 	<a-tab-pane key="2" tab="评审指标">
        <div class="flex flex-between align-items-end">
          <a-radio-group v-model="applyType"  @change="applyTypeChange">
            <a-radio-button value="4"> 网络育人创新联盟 </a-radio-button>
            <!-- <a-radio-button value="1"> 典型小案例申报 </a-radio-button> -->
          </a-radio-group>
          <div class="add-indicators" @click="addIndicators">添加指标</div>
        </div>

        <a-table
          class="table"
          :columns="columns"
          :loading="loading"
          :data-source="targetData"
          bordered
          :rowKey="(record) => record.id"
          :pagination="false"
        >
          <span slot="oneTarget" slot-scope="text">{{ text }}</span>
          <template  slot="content" slot-scope="text, record">
          	<div >
          		<span style="white-space: pre-line;text-align: left;font-size: 18px;line-height: 28px;display: block;">{{transform(text)}}</span>
          	</div>
          </template>
          <div
            slot="operation"
            slot-scope="text, record"
            class="flex flex-around"
          >
            <div
              class="flex align-items-center"
              style="cursor: pointer"
              @click="editTarget(record)"
            >
              <img class="img-box" src="../../assets/images/img42.png" alt="" />
              <span>编辑</span>
            </div>
            <a-popconfirm
              title="你确定删除该指标吗?"
              ok-text="确定"
              cancel-text="取消"
              @confirm="confirm(record)"
            >
              <div class="flex align-items-center" style="cursor: pointer">
                <img
                  class="img-box"
                  src="../../assets/images/img43.png"
                  alt=""
                />
                <span>删除</span>
              </div>
            </a-popconfirm>

            <div class="flex align-items-center" style="cursor: pointer">
              <img class="img-box" src="../../assets/images/sort.png" alt="" />
              <span>排序</span>
            </div>
          </div>
        </a-table>
      </a-tab-pane>
    </a-tabs>
   <a-modal v-model="showBindExpert" title="绑定专家">
      <div style="height: 400px" class="flex flex-col" v-if="showBindExpert">
        <div>
          <a-input-search placeholder="请输入专家名称" @search="onSearch" />
        </div>
        <ul style="margin-top: 20px; overflow: auto" class="flex-1">
          <li style="margin: 4px 0" v-for="item in expertLists" :key="item.id">
            <div class="nowrap">
              <a-checkbox
                @change="onChange1(item, $event)"
                style="font-size: 16px"
              >
                {{ item.realname }}
              </a-checkbox>
            </div>
          </li>
        </ul>
      </div>
      <!-- <a-select
          placeholder="请选择评审专家"
          style="width: 100%"
          mode="multiple"
          @change="addExpertChange"
        >
          <a-select-option
            :value="item.id"
            v-for="item in expertList"
            :key="item.id"
          >
            
          </a-select-option>
        </a-select> -->
      <template slot="footer">
        <a-button style="background: #9A0B00; color: #fff" @click="hideModal"
          >添加</a-button
        >
      </template>
    </a-modal>
     <!-- 添加，编辑指标 -->
    <add-target ref="addTarget" @addTarget="addTarget"></add-target>
  </div>
</template>

<script>
import {
  userLxExpertDateView,
  userLxExpertDateSet,
  lxApplyApplySettingData,
  getLxExpertList,
  lxExpertApplyAdd,
} from "../../api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import addTarget from "./addTarget.vue";
import { getAction, deleteAction,postAction} from "@/api/index";
moment.locale("zh-cn");
export default {
  name: "",
  props: {},
  components: {
    addTarget,
  },
  data() {
    return {
      zh_CN,
      locale,
      showBindExpert: false,
      list: [],
      expertList: [],
      expertLists: [],
      isDisabled: true,
      isRanagePickerDisabled: true,
      currentTime: [],
      startTime: "",
      endTime: "",
      selectExpertList: [],
      schoolIdList: [],
      onCheckIdList: [],
      current: null,
      applyType: "4",
      targetData: [],
      izScoring: true,
      izReview:true,
      columns: [
        {
          title: "评价维度",
          dataIndex: "oneTarget",
          key: "oneTarget",
          align: "center",
          width: 120,
          scopedSlots: { customRender: "oneTarget" },
          customRender: (text, record, index) => {
            const obj = {
              children: record.oneTarget,
              attrs: {},
            };
            obj.attrs.rowSpan = this.columnsInit(
              record.oneTarget,
              this.targetData,
              "oneTarget",
              index
            );
            return obj;
          },
        },
        {
          title: "评价指标",
          dataIndex: "twoTarget",
          key: "twoTarget",
          align: "center",
          width: 180,
        },
        {
          title: "评价要点",
          dataIndex: "content",
          key: "content",
          scopedSlots: { customRender: "content" },
          ellipsis: true,
          align: "center",
        },
        {
          title: "分值",
          dataIndex: "score",
          key: "score",
          width: 80,
          align: "center",
        },
        {
          title: "排序",
          dataIndex: "sort",
          key: "sort",
          width: 80,
          align: "center",
        },
        {
          title: "操作",
          dataIndex: "address",
          key: "address",
          align: "center",
          scopedSlots: { customRender: "operation" },
          width: 280,
        },
      ],
      loading: false,
    };
  },
  computed: {},
  watch: {
  },
  created() {},
  mounted() {
    this.reportTime();
    this.getLxApplyApplySettingData();
    this.getStatus();
   
  },
  methods: {
    getStatus(){
      getAction('/lx/lxApply/getReviewAndScore',{}).then((res) => {
        if (res.code === 200) {
          // console.log(res,"333");
          this.izScoring=res.result.izScoring==1?true:false;
          this.izReview=res.result.izReview==1?true:false;
        }else{
          this.$message.error(res.message);
        }
      });
    },
  	addTarget() {
      this.getTargetList();
    },
  	callback(key) {
      if (key == 2) {
        this.getTargetList();
      }
    },
    // 指标列表
    getTargetList() {
      let params = {
        applyType: this.applyType,
      };
      this.loading = true;
      getAction("/lx/lxExpertItem/tablelist", params).then((res) => {
//    	console.log(res);
        if (res.code == 200) {
          this.targetData = res.result.dataList;
//        this.remark = res.result.remark;
          this.loading = false;
          if(!res.result.hasOne){
//        	console.log(res.result.hasTwo);
            this.columns = this.columns.filter(item => item.title != '评价维度')
          }else{
            this.columns =  [
              {
                title: "评价维度",
                dataIndex: "oneTarget",
                key: "oneTarget",
                align: "center",
                width: 120,
                scopedSlots: { customRender: "oneTarget" },
                customRender: (text, record, index) => {
                  const obj = {
                    children: record.oneTarget,
                    attrs: {},
                  };
                  obj.attrs.rowSpan = this.columnsInit(
                    record.oneTarget,
                    this.targetData,
                    "oneTarget",
                    index
                  );
                  return obj;
                },
              },
              {
                title: "评价指标",
                dataIndex: "twoTarget",
                key: "twoTarget",
                align: "center",
                width: 180,
              },
              {
                title: "评价要点",
                dataIndex: "content",
                key: "content",
                ellipsis: true,
                align: "center",
              },
              {
                title: "分值",
                dataIndex: "score",
                key: "score",
                width: 80,
                align: "center",
              },
              {
                title: "排序",
                dataIndex: "sort",
                key: "sort",
                width: 80,
                align: "center",
              },
              {
                title: "操作",
                dataIndex: "address",
                key: "address",
                align: "center",
                scopedSlots: { customRender: "operation" },
                width: 280,
              },
            ]
          }
        }
      });
    },
    columnsInit(text, data, key, index) {
      if (index !== 0 && text == data[index - 1][key]) {
        return 0;
      }
      let rowSpan = 1; //判断下一行是否相等
      for (let i = index + 1; i < data.length; i++) {
        if (text !== data[i][key]) {
          break;
        }
        rowSpan++;
      }
      return rowSpan;
    },
    transform(text){
    	return String(text).replaceAll("\\n","\n");
    },
    // 添加指标
    addIndicators() {
      this.$refs.addTarget.init("add", this.applyType);
    },
    // 编辑指标
    editTarget(record) {
      this.$refs.addTarget.init("edit", this.applyType, record);
    },
    // 删除指标
    confirm(record) {
      deleteAction("/lx/lxExpertItem/delete", { id: record.id }).then((res) => {
        if (res.code == 200) {
          this.$message.success("删除成功");
          this.getTargetList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //日期时间选择器代码
    onChange(value, dateString) {
      //选择的开始时间
      this.startTime = new Date(dateString[0]).getTime();
      this.endTime = new Date(dateString[1]).getTime();
    },
    openTree(currentItem, index) {
      this.current = index;
      this.list.map((item) => {
        if (item.text === currentItem.text) {
          currentItem.isShow = !currentItem.isShow;
        }
        if (item.text !== currentItem.text) {
          item.isShow = false;
        }
        return item;
      });
      this.onCheckIdList = []; //每次切换时置空
    },
    // addExpertChange(e) {
    // },
    showBindExpertPop() {
      if (this.onCheckIdList && this.onCheckIdList.length > 0) {
        this.getExpertList();
        this.showBindExpert = true;
      } else {
        this.$message.info("请选择学校");
      }
    },
    getExpertList() {
      getLxExpertList({
        roleCode: "expert-role",
      }).then((res) => {
        if (res.code === 200) {
          this.expertList = res.result;
          this.expertLists = this.expertList;
        }
      });
    },
    onCheck(checkedKeys, info) {
      console.log("onCheck", checkedKeys, info);
    },
    getApplyVoNum(item) {
      let applyVoNum = item.filter((items1) => {
        if (items1.expertList.length === 0) {
          return items1;
        }
      });
      return applyVoNum.length;
    },
    getLxApplyApplySettingData() {
      lxApplyApplySettingData().then((res) => {
        if (res.code === 200) {
          this.list = res.result.filter((item) => {
            item.isShow = false;
            return item;
          });
          for (var i = 0; i < this.list.length; i++) {
            for (var j = 0; j < this.list[i].school.length; j++) {
              this.schoolIdList.push(this.list[i].school[j].id);
              this.list[i].school[j].scopedSlots = {
                title: "school",
              };
              for (
                var u = 0;
                u < this.list[i].school[j].applyVoList.length;
                u++
              ) {
                this.list[i].school[j].applyVoList[u].scopedSlots = {
                  title: "expert",
                };
                this.list[i].school[j].applyVoList[u].realname =
                  this.list[i].school[j].applyVoList[u].name;
              }
            }
          }
          if (this.current !== null) {
            this.list[this.current].isShow = true;
          } else {
            this.list[0].isShow = true;
          }
        }
      });
    },
    onOk(value) {
      console.log("onOk: ", value);
    },
    hideModal() {
      if (this.selectExpertList && this.selectExpertList.length > 0) {
        let data = {
          applyIds: this.onCheckIdList,
          expertUserIds: this.selectExpertList,
        };
        lxExpertApplyAdd(data).then((res) => {
          if (res.code === 200) {
            this.$message.success(res.message);
            this.showBindExpert = false;
            this.getLxApplyApplySettingData();
            this.list.map((item) => {
              item.isShow = false;
              return item;
            });
            this.$forceUpdate;
          }
        });
      } else {
        this.$message.info("请选择评审专家");
      }
    },
    onCheckTree(checkedKeys) {
      this.onCheckIdList = checkedKeys;
    },
    //  编辑时间
    editTime() {
      this.isRanagePickerDisabled = false;
      this.isDisabled = false;
    },
    qhReview(){
      let params = {
        izReview: this.izReview?1:0,
      };
      postAction("/lx/lxApply/reviewAndScoreSet", params).then((res) => {
//    	console.log(res);
        if (res.code == 200) {
          this.$message.success("设置成功");
        }else{
          this.$message.success(res.message);
        }
      });
    },
    qhScore(){
      let params = {
        izScoring: this.izScoring?1:0,
      };
      postAction("/lx/lxApply/reviewAndScoreSet", params).then((res) => {
//    	console.log(res);
        if (res.code == 200) {
          this.$message.success("设置成功");
        }else{
          this.$message.success(res.message);
        }
      });
    },
    // 时间选择完成
    selectTimeOk() {
      let obj = {
        startTime: this.startTime,
        endTime: this.endTime,
      };
      userLxExpertDateSet(obj).then((res) => {
        if (res.code == 200) {
          this.$message.success("保存成功");
        }
      });
      this.isRanagePickerDisabled = true;
      this.isDisabled = true;
    },
    //获取上报时间
    reportTime() {
      userLxExpertDateView().then((res) => {
        let data = res.result;
        if (res.code == 200) {
          if (data.startTime !== undefined && data.endTime !== undefined) {
            this.startTime = data.startTime;
            this.endTime = data.endTime;
            this.currentTime = [
              moment(this.formatTime(this.startTime)),
              moment(this.formatTime(this.endTime)),
            ];
          } else {
            this.startTime = "开始时间";
            this.endTime = "结束时间";
            this.currentTime = [this.endTime, this.startTime];
          }
        }
      });
    },
    //时间转换成日期
    formatTime(data) {
      var date = new Date(Number(data));
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var m =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      return Y + M + D + h + m;
    },
    applyTypeChange(e) {
      const value = e.target.value;
      this.applyType = value;
      this.getTargetList();
    },
    //搜索专家
    onSearch(value) {
      // let oldData = this.expertList
      if (value === "") {
        this.expertLists = this.expertList;
      } else {
        this.expertLists = this.expertList.filter((item) => {
          if (item.realname.indexOf(value) !== -1) {
            return item;
          }
        });
      }
    },
    onChange1(item1, e) {
      item1.checked = e.target.checked;
      const arr = this.expertLists.filter((item) => {
        if (item.checked) {
          return item.id;
        }
      });
      this.selectExpertList = arr.map((item) => item.id);
      // this.selectExpertList.push(item1);
      // for (let i = 0; i < this.selectExpertList.length; i++) {
      //   if (this.selectExpertList[i] === item1) {
      //     console.log(this.selectExpertList);
      //   } else {
      //    console.log(this.selectExpertList);
      //   }
      // }
    },
  },
};
</script>

<style scoped lang="scss">
.c-box {
  height: 100%;
  overflow: auto;
}
.img-box {
  width: 19px;
  height: 19px;
  margin-right: 8px;
}
.text1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #9A0B00;
}
.text-box {
  margin: 25px 0 18px 0;
}
.time-compontent {
  margin-left: 20px;
  margin-top: 10px;
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.line-style {
  height: 1px;
  margin-bottom: 20px;
  background: #e0e0e0;
}
.review-menu {
  min-width: 231px;
  height: 30px;
  line-height: 28px;
  padding-left: 11px;
  text-align: center;
  margin-bottom: 28px;
  color: #9A0B00;
  margin-left: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  cursor: pointer;
  border: 2px solid #9A0B00;
  position: relative;
  border-radius: 15px;
}
.arrow_down {
  position: absolute;
  bottom: -12px;
  left: 50%;
  transform: translate(-50%, 0);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #9A0B00;
}
.review-menu-content {
  padding: 20px;
  margin-bottom: 20px;
}

// 编辑完成按钮
.position {
  position: absolute;
  top: 19px;
  left: 440px;
}
.add-btn {
  width: 116px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin: 20px 0;
  background: #9A0B00;
  border-radius: 10px;
  font-size: 16px;
  cursor: pointer;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.btn-box {
  margin-top: 8px;
  margin-left: 30px;
  width: 242px;
  height: 40px;
}
.btn {
  width: 116px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  border-radius: 10px;
  cursor: pointer;
}
.border-btn {
  border: 1px solid #9A0B00;
  color: #9A0B00;
}
.bg-btn {
  color: #fff !important;
  background: #9A0B00 !important;
}
.opacity6 {
  opacity: 0.6;
}
.align-items-end {
    align-items: flex-end;
}

.flex-between {
    justify-content: space-between;
}
.flex {
    display: flex;
}
.table{
	 /deep/ .ant-table-thead > tr > th {
	     font-size: 18px!important;
	 }
	/deep/ .ant-table-tbody > tr > td {
	     font-size: 18px;
	 }
}
/deep/ .ant-tree-treenode-switcher-close {
  display: flex !important;
}
/deep/ .ant-tree-treenode-switcher-close {
  display: flex !important;
}
/deep/ .ant-tabs-tab-active {
  color: #9A0B00 !important;
}
/deep/ .ant-tabs-ink-bar {
  background-color: #9A0B00 !important;
}
/deep/ .ant-radio-button-wrapper {
  height: 40px;
  line-height: 40px;
}
/deep/ .ant-radio-button-wrapper-checked {
  background: #9A0B00;
  border: 1px solid #d9d9d9;
  color: #ffffff;
}
/deep/ .ant-radio-button-wrapper:hover {
  color: #9A0B00;
}
/deep/ .ant-radio-button-wrapper-checked:hover {
  color: #ffffff;
}
/deep/
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  border-color: #9A0B00;
}
/deep/ .ant-table-column-title {
  color: #73593b;
}
.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
  background-color: #9A0B00;
}
.add-indicators {
  width: 96px;
  height: 32px;
  background: #9A0B00;
  border-radius: 6px;
  text-align: center;
  line-height: 32px;
  color: #ffffff;
  cursor: pointer;
}
.table {
  margin-top: 20px;
  .img-box {
    width: 18px;
    height: 18px;
    margin-right: 9px;
  }
}
/deep/ .ant-tabs-tab {
  font-size: 18px;
}
/deep/ .ant-switch-checked{
  background-color: #9A0B00;
}
</style>
